import { Autocomplete, Box, Checkbox, CircularProgress, FormControl, FormControlLabel, InputLabel } from "@mui/material";
import { GetAutocompleteResult } from "hooks/work-items/useWorkItemAutocompleteResource";
import { WorkItemTextField } from "../shared/WorkItemInputStyles";

interface IWorkItemBulkOperationResourceProps {
    idSuffix: string,
    resources: GetAutocompleteResult[] | null,
    onChange: (e: any, newValue: string | GetAutocompleteResult | null) => void
    onKeyUp: (e: any) => void,
    loadingResources: boolean,
    errorResources: string | null,
    onChangeCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void,
    checked: boolean | false,
    resourceCheckboxLabel: string | "Only as primary resource",
    disabled: boolean | false,
    resourceValue?: string | GetAutocompleteResult | null,
    checkedForResourceInProgressCheckbox: boolean | false,
    onChangeForResourceInProgressCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void,
    resourceOnInProgressCheckboxLabel: string | "Reassign on in progress tasks"
}

const ForwardWorkItemInputField = (props: any) => {
    return (
        <FormControl
            sx={{ paddingRight: 1 }}
            variant="standard"
            fullWidth>
            <InputLabel
                shrink htmlFor="work-item-input-field">
                {"Resource"}:
            </InputLabel>
            <WorkItemTextField
                id="work-item-input-field"
                fullWidth
                ref={(input) => {
                    if (props.ref) {
                        props.ref(input);
                    }
                }}
                {...props}
            />
        </FormControl>
    );
};

const WorkItemBulkOperationResource = (props: IWorkItemBulkOperationResourceProps) => {   
    return (
        <>
            <Box>
                <Autocomplete                    
                    sx={{'& #free-solo-with-text-demo': {padding: '3px 4px 7.5px 5px !important'}}}
                    value={props.resourceValue ?? null}
                    onChange={(event: any, newValue: string | GetAutocompleteResult | null) => {
                        props.onChange(event, newValue);
                    }}
                    onKeyUp={props.onKeyUp}
                    disabled={props.disabled}
                    handleHomeEndKeys
                    noOptionsText="No resources found"                    
                    id={"bulk-update-ops--resources-" + props.idSuffix}
                    options={props.resources ?? [{ fullName: 'No resources found', userId: '0' }]}
                    getOptionLabel={(option) => {
                        if (typeof option === 'string') {
                            return option;
                        }
                        else {
                            return option.fullName;
                        }
                    }}
                    renderOption={props.loadingResources ? (props, option) => <li><CircularProgress /></li> : (props, option) => <li {...props}>{(option as GetAutocompleteResult).fullName}</li>}
                    freeSolo
                    clearOnBlur
                    renderInput={(params) => (
                        <ForwardWorkItemInputField  {...params} />
                    )}
                />
            </Box>
            <Box
                sx={{ paddingLeft: '8px' }}>
                <FormControlLabel
                    id={"bulk-update-ops-set-primary-" + props.idSuffix}
                    control={<Checkbox
                        checked={props.checked}  // Controlled by the state
                        onChange={props.onChangeCheckbox}
                    />}
                    label={props.resourceCheckboxLabel} />

                {props.checked && <FormControlLabel 
                    control={<Checkbox
                        checked={props.checkedForResourceInProgressCheckbox}  // Controlled by the state
                        onChange={props.onChangeForResourceInProgressCheckbox}
                    />}
                    label={props.resourceOnInProgressCheckboxLabel} />}
            </Box>

        </>
    );
}


export default WorkItemBulkOperationResource;